/* Romi Wellness yoga character — illustrated rig. renderPose(pose) -> SVG <g> string, grounded on y=GROUND, centred on x=200 */
var RomiFigure=window.RomiFigure=(function(){
const GROUND=322, CX=200;
const C={
 skin:{base:'#D49F7D',shade:'#A9704F',light:'#EEC6A8'},
 hair:{base:'#3A2820',shade:'#22160F',light:'#6B4E3C'},
 leg:{base:'#2D4A3A',shade:'#18291F',light:'#4F7763'},
 top:{base:'#A5B99B',shade:'#7C9473',light:'#D2DECB'},
 tie:'#B5674A', lip:'#A55A48', blush:'#E28A74', eye:'#2A1D17'
};
const LEN={torso:84,ua:52,fa:46,hand:17,th:74,sh:70};
const LIGHT=norm([-0.5,-0.86]);
function norm(v){const l=Math.hypot(v[0],v[1])||1;return[v[0]/l,v[1]/l]}
const add=(a,b)=>[a[0]+b[0],a[1]+b[1]],sub=(a,b)=>[a[0]-b[0],a[1]-b[1]],mul=(a,k)=>[a[0]*k,a[1]*k],dot=(a,b)=>a[0]*b[0]+a[1]*b[1];
const dir=a=>[Math.cos(a*Math.PI/180),Math.sin(a*Math.PI/180)];
const angOf=v=>Math.atan2(v[1],v[0])*180/Math.PI;
const lerp=(a,b,t)=>[a[0]+(b[0]-a[0])*t,a[1]+(b[1]-a[1])*t];
const f=n=>Math.round(n*100)/100;
function darken(hex,k){const n=parseInt(hex.slice(1),16);let r=n>>16,g=n>>8&255,b=n&255;r=Math.round(r*k);g=Math.round(g*k);b=Math.round(b*k);return'#'+((1<<24)+(r<<16)+(g<<8)+b).toString(16).slice(1)}
function pal(p,k){return k===1?p:{base:darken(p.base,k),shade:darken(p.shade,k),light:darken(p.light,k)}}
function ik(root,target,a,b,bend){
 let d=sub(target,root),dist=Math.hypot(d[0],d[1]);dist=Math.min(Math.max(dist,Math.abs(a-b)+.5),a+b-.01);
 const base=angOf(d),cosA=(a*a+dist*dist-b*b)/(2*a*dist),al=Math.acos(Math.max(-1,Math.min(1,cosA)))*180/Math.PI;
 const mid=add(root,mul(dir(base+bend*al),a));const end=add(mid,mul(norm(sub(target,mid)),b));return[mid,end];
}
/* smooth closed path through points (Catmull-Rom) */
function smooth(pts,closed=true){
 const n=pts.length;let d=`M${f(pts[0][0])},${f(pts[0][1])}`;
 for(let i=0;i<(closed?n:n-1);i++){
  const p0=pts[(i-1+n)%n],p1=pts[i],p2=pts[(i+1)%n],p3=pts[(i+2)%n];
  const c1=add(p1,mul(sub(p2,p0),1/6)),c2=sub(p2,mul(sub(p3,p1),1/6));
  d+=`C${f(c1[0])},${f(c1[1])} ${f(c2[0])},${f(c2[1])} ${f(p2[0])},${f(p2[1])}`;
 }
 return d+(closed?'Z':'');
}
/* ribbon outline from centreline samples [{p,w}] */
function ribbon(s,capStart=true,capEnd=true){
 const n=s.length,Lp=[],Rp=[];
 for(let i=0;i<n;i++){
  const t=norm(sub(s[Math.min(n-1,i+1)].p,s[Math.max(0,i-1)].p)),nn=[-t[1],t[0]];
  s[i].t=t;Lp.push(add(s[i].p,mul(nn,s[i].w)));Rp.push(sub(s[i].p,mul(nn,s[i].w)));
 }
 const prune=(arr)=>{const out=[arr[0]];for(let i=1;i<arr.length;i++){const prev=out[out.length-1];if(dot(sub(arr[i],prev),s[i].t)>-0.2||i===arr.length-1)out.push(arr[i])}return out};
 const L=prune(Lp),R=prune(Rp);
 const e=s[n-1],b=s[0],pts=[...L];
 if(capEnd)pts.push(add(e.p,mul(e.t,e.w*0.95)));
 pts.push(...R.reverse());
 if(capStart)pts.push(sub(b.p,mul(b.t,b.w*0.95)));
 return pts;
}
function samples(joints,profiles){
 const out=[];
 for(let k=0;k<joints.length-1;k++){
  const A=joints[k],B=joints[k+1],prof=profiles[k];
  prof.forEach(([t,w],i)=>{if(k>0&&i===0)return;out.push({p:lerp(A,B,t),w})});
 }
 return out;
}
let uid=0,bbox=null;
function track(pts){pts.forEach(p=>{bbox.x0=Math.min(bbox.x0,p[0]);bbox.x1=Math.max(bbox.x1,p[0]);bbox.y0=Math.min(bbox.y0,p[1]);bbox.y1=Math.max(bbox.y1,p[1])})}
/* shaded fill of a world-space path: shade base, base copy nudged toward light (blurred), soft highlight */
function shaded(d,p,opts={}){
 const id='rf'+(++uid),off=opts.off??3.2,hl=opts.hl??0.5;
 const o=mul(LIGHT,off),h=mul(LIGHT,-off*0.9);
 return `<clipPath id="${id}"><path d="${d}"/></clipPath><path d="${d}" fill="${p.shade}"/>`+
  `<g clip-path="url(#${id})"><path d="${d}" fill="${p.base}" transform="translate(${f(o[0])},${f(o[1])})" filter="url(#rfBlur)"/>`+
  (hl?`<path d="${d}" fill="none" stroke="${p.light}" stroke-width="${opts.hw||2.4}" opacity="${hl}" transform="translate(${f(-h[0]*0.35)},${f(-h[1]*0.35)})" filter="url(#rfBlur)"/>`:'')+`</g>`;
}
/* ---------- limbs ---------- */
const LEGPROF=[[[0,15],[.3,13.6],[.62,11.2],[.9,8.8],[1,8.2]],[[0,8.2],[.28,8.6],[.55,7],[.8,5.4],[1,4.4]]];
const ARMPROF=[[[0,6.8],[.35,6.2],[.75,5],[1,4.5]],[[0,4.5],[.3,4.8],[.7,3.9],[1,3.3]]];
function leg(hip,knee,ankle,k=1){
 const pk=pal(C.skin,k),pl=pal(C.leg,k);
 const sk=ribbon(samples([hip,knee,ankle],LEGPROF),false,true);track(sk);
 const cut=lerp(knee,ankle,.86);
 const lp=[LEGPROF[0].map(([t,w])=>[t,w+0.7]),[[0,8.9],[.3,9.2],[.62,7.6],[.9,6.2],[1,5.9]]];
 const lg=ribbon(samples([hip,knee,cut],lp),false,false);
 const kneeC=`<circle cx="${f(knee[0])}" cy="${f(knee[1])}" r="8.6" fill="${pl.base}"/>`;
 // hem
 const t=norm(sub(ankle,knee)),nn=[-t[1],t[0]],a=add(cut,mul(nn,6.2)),b=sub(cut,mul(nn,6.2));
 return shaded(smooth(sk),pk,{off:2.4})+kneeC+shaded(smooth(lg),pl,{off:3.4,hl:.55,hw:3})+
  `<path d="M${f(a[0])},${f(a[1])}L${f(b[0])},${f(b[1])}" stroke="${pl.shade}" stroke-width="1.2" stroke-linecap="round" opacity=".7"/>`;
}
function arm(sh,el,wr,handAng,k=1,prayer=false){
 const pk=pal(C.skin,k);
 const hEnd=add(wr,mul(dir(handAng),LEN.hand)),hMid=add(wr,mul(dir(handAng),LEN.hand*.5));
 const prof=[...ARMPROF,[[0,3.3],[.35,prayer?3.2:4.4],[.75,prayer?3:3.6],[1,2.2]]];
 const pts=ribbon(samples([sh,el,wr,hEnd],prof),true,true);track(pts);
 // thumb
 const n=[-dir(handAng)[1],dir(handAng)[0]];
 const th=ribbon([{p:add(wr,mul(dir(handAng),3)),w:1.9},{p:add(add(wr,mul(dir(handAng),9)),mul(n,4.2*(prayer?0:1))),w:1.5}],true,true);
 return shaded(smooth(pts),pk,{off:2.2,hw:1.8})+(prayer?'':shaded(smooth(th),pk,{off:1,hl:0}));
}
/* feet: side profile (x toward toes, y toward sole) or front (toes to viewer) */
function footSide(ankle,ang,k=1,flipSole=false){
 const pk=pal(C.skin,k);
 const local=[[-3,-4.5],[-6.5,-1.5],[-7.5,3.5],[-5.5,7.2],[0,8.2],[10,8.4],[18.5,8.2],[23,6.6],[23,3.8],[18,1.6],[11,-0.4],[5,-3.8]];
 const flip=flipSole?-1:1,c=dir(ang),s=[-c[1],c[0]];
 const pts=local.map(([x,y])=>add(ankle,add(mul(c,x),mul(s,y*flip))));track(pts);
 return shaded(smooth(pts),pk,{off:1.6,hw:1.4});
}
function footFront(ankle,side,k=1){
 const pk=pal(C.skin,k),m=side;// +1 toes flare right, -1 left
 const local=[[-4.6,-2],[-5.4,3],[-7,6.6],[-6.4,9.6],[-2,10.6],[3,10.6],[7,9.8],[7.8,7],[5.6,3],[4.6,-2]];
 const pts=local.map(([x,y])=>add(ankle,[x*m,y]));track(pts);
 const toes=[-3.6,-1,1.6,4].map(x=>`<path d="M${f(ankle[0]+x*m)},${f(ankle[1]+9.4)}v1" stroke="${pk.shade}" stroke-width=".7" stroke-linecap="round" opacity=".6"/>`).join('');
 return shaded(smooth(pts),pk,{off:1.6,hw:1.4})+toes;
}
/* ---------- torso (local frame: origin = hips, -y toward neck, +x = right in front view / chest in side view) ---------- */
const TORSO_FRONT=[[0,-90],[6.5,-89],[8,-84],[17,-80],[25,-77],[27.5,-71],[24,-63],[21.5,-54],[20.5,-47],[18,-38],[16.5,-30],[18.5,-20],[22.5,-10],[24,0],[21,8],[12,12],[0,13]];
const TORSO_SIDE=[[-1,-90],[5.5,-88],[7,-84],[12.5,-74],[15.5,-60],[15,-52],[11,-46],[10,-36],[11.5,-24],[11,-12],[8,0],[2,9],[-8,12],[-13.5,8],[-15.5,-2],[-13.5,-14],[-9.5,-28],[-8.5,-40],[-10.5,-56],[-11.5,-70],[-8.5,-82],[-6,-88]];
function mirror(half){const r=half.slice(1,-1).map(([x,y])=>[-x,y]).reverse();return[...half,...r]}
function torso(H,ang,view,cover){
 const T=view==='front'?mirror(TORSO_FRONT):TORSO_SIDE,rot=ang+90,id='rt'+(++uid);
 const xf=`translate(${f(H[0])},${f(H[1])}) rotate(${f(rot)})`;
 const toW=([x,y])=>{const r=rot*Math.PI/180;return[H[0]+x*Math.cos(r)-y*Math.sin(r),H[1]+x*Math.sin(r)+y*Math.cos(r)]};
 track(T.map(toW));
 const d=smooth(T);
 const lr=rot*Math.PI/180,Ll=[LIGHT[0]*Math.cos(-lr)-LIGHT[1]*Math.sin(-lr),LIGHT[0]*Math.sin(-lr)+LIGHT[1]*Math.cos(-lr)];
 const nud=(k)=>`translate(${f(Ll[0]*k)},${f(Ll[1]*k)})`;
 let topD,legD,extra='';
 if(view==='front'){
  legD='M-40,-27 C-20,-29.5 20,-29.5 40,-27 L40,30 L-40,30Z';
  topD='M-40,-25 C-20,-27.5 20,-27.5 40,-25 L40,-67 C31,-67 23,-71 17,-80 L16,-95 L9.5,-95 L9.5,-82 C7,-70 -7,-70 -9.5,-82 L-9.5,-95 L-16,-95 L-17,-80 C-23,-71 -31,-67 -40,-67Z';
  extra=`<path d="M-15,-50 C-9,-45 -3,-46 0,-50 C3,-46 9,-45 15,-50" fill="none" stroke="${C.top.shade}" stroke-width="1.3" opacity=".55" filter="url(#rfBlur)"/>`+
   `<path d="M-7,-85 Q-3,-83 0,-84 Q3,-83 7,-85" fill="none" stroke="${C.skin.shade}" stroke-width=".8" opacity=".5"/>`+
   `<path d="M0,-22 v4" stroke="${C.leg.shade}" stroke-width="1" opacity=".5"/>`;
 }else{
  legD='M-40,-26 C-10,-29 10,-30 40,-29 L40,30 L-40,30Z';
  topD='M-40,-24 C-10,-27 10,-28 40,-27 L40,-64 C24,-66 13,-73 7.5,-85 L1,-95 L-14,-95 L-12,-84 C-22,-80 -30,-78 -40,-78Z';
  extra=`<path d="M8,-50 C11,-47 12,-44 10.5,-42" fill="none" stroke="${C.top.shade}" stroke-width="1.3" opacity=".6" filter="url(#rfBlur)"/>`;
 }
 if(cover){
  const mid='rm'+uid,gid='rg'+uid;
  return `<g transform="${xf}"><clipPath id="${id}"><path d="${d}"/></clipPath><linearGradient id="${gid}" x1="0" y1="2" x2="0" y2="17" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff"/><stop offset="1" stop-color="#000"/></linearGradient>`+
   `<mask id="${mid}" maskUnits="userSpaceOnUse" x="-60" y="-60" width="120" height="120"><rect x="-60" y="-60" width="120" height="120" fill="url(#${gid})"/></mask>`+
   `<clipPath id="${id}b"><path d="${legD}"/></clipPath><g mask="url(#${mid})"><g clip-path="url(#${id})"><g clip-path="url(#${id}b)"><path d="${legD}" fill="${C.leg.shade}"/><path d="${legD}" fill="${C.leg.base}" transform="${nud(5)}" filter="url(#rfBlur)"/><ellipse cx="0" cy="7" rx="26" ry="12" fill="${C.leg.base}" filter="url(#rfBlur)"/>`+
   `</g></g></g>`+
   (view==='front'?`<path d="M0,-22 v4" stroke="${C.leg.shade}" stroke-width="1" opacity=".5"/>`:'')+`</g>`;
 }
 return `<g transform="${xf}"><clipPath id="${id}"><path d="${d}"/></clipPath>`+
  `<path d="${d}" fill="${C.skin.shade}"/><g clip-path="url(#${id})">`+
  `<path d="${d}" fill="${C.skin.base}" transform="${nud(3.4)}" filter="url(#rfBlur)"/>`+
  `<path d="${legD}" fill="${C.leg.shade}"/><path d="${legD}" fill="${C.leg.base}" transform="${nud(5)}" clip-path="url(#${id})" filter="url(#rfBlur)"/>`+
  `<path d="${topD}" fill="${C.top.shade}"/><path d="${topD}" fill="${C.top.base}" transform="${nud(4.5)}" filter="url(#rfBlur)"/>`+
  `<path d="${d}" fill="none" stroke="${C.top.light}" stroke-width="3" opacity=".35" transform="${nud(-1.2)}" filter="url(#rfBlur)"/>`+
  extra+`</g></g>`;
}
/* ---------- head ---------- */
function headFront(Hc,ang,eyes){
 const rot=ang+90,id='rh'+(++uid);
 const face='M0,-16.8 C9.2,-16.8 13.6,-9.4 13.6,-1.2 C13.6,7.8 8.2,16.4 0,17.2 C-8.2,16.4 -13.6,7.8 -13.6,-1.2 C-13.6,-9.4 -9.2,-16.8 0,-16.8Z';
 const hair='M-14.4,2.5 C-15.6,-12 -9.5,-20.2 0,-20.2 C9.5,-20.2 15.6,-12 14.4,2.5 C13.6,-3 12.4,-7.2 9.6,-9.8 C6.6,-12.2 2.6,-12.4 -0.6,-10.6 C-3,-12.6 -7.6,-12.2 -10.6,-8.8 C-12.8,-6.2 -13.8,-2 -14.4,2.5Z';
 const eye=x=>eyes==='closed'
  ?`<path d="M${x-3},-0.6 Q${x},2 ${x+3},-0.6" fill="none" stroke="${C.eye}" stroke-width="1.15" stroke-linecap="round"/><path d="M${x+(x<0?-3:3)},-0.6 l${x<0?-1:1},0.4" stroke="${C.eye}" stroke-width=".8" stroke-linecap="round"/>`
  :`<path d="M${x-3.2},0.2 Q${x},-2.6 ${x+3.2},0.2" fill="none" stroke="${C.eye}" stroke-width="1.2" stroke-linecap="round"/><ellipse cx="${x}" cy="0.5" rx="1.6" ry="1.7" fill="${C.eye}"/><circle cx="${x+0.5}" cy="0" r=".45" fill="#fff" opacity=".8"/><path d="M${x-2.4},1.9 Q${x},2.9 ${x+2.4},1.9" fill="none" stroke="${C.skin.shade}" stroke-width=".6" opacity=".6"/>`;
 track([Hc].map(p=>[p[0]-16,p[1]-21]).concat([[Hc[0]+16,Hc[1]+21]]));
 return `<g transform="translate(${f(Hc[0])},${f(Hc[1])}) rotate(${f(rot)})"><clipPath id="${id}"><path d="${face}"/></clipPath>`+
  `<ellipse cx="-13.4" cy="1.5" rx="2.6" ry="4.2" fill="${C.skin.shade}"/><ellipse cx="13.4" cy="1.5" rx="2.6" ry="4.2" fill="${C.skin.shade}"/>`+
  `<path d="${face}" fill="${C.skin.shade}"/><g clip-path="url(#${id})"><path d="${face}" fill="${C.skin.base}" transform="translate(-1.6,-2.4)" filter="url(#rfBlur)"/>`+
  `<circle cx="-7.2" cy="6" r="3.2" fill="${C.blush}" opacity=".28" filter="url(#rfBlur)"/><circle cx="7.2" cy="6" r="3.2" fill="${C.blush}" opacity=".28" filter="url(#rfBlur)"/></g>`+
  eye(-5.4)+eye(5.4)+
  `<path d="M-8.4,-5.6 Q-5.4,-7.4 -2.4,-6" fill="none" stroke="${C.hair.base}" stroke-width="1.1" stroke-linecap="round"/><path d="M8.4,-5.6 Q5.4,-7.4 2.4,-6" fill="none" stroke="${C.hair.base}" stroke-width="1.1" stroke-linecap="round"/>`+
  `<path d="M0.4,1 Q1.6,5 0,6.2 Q-0.8,6.4 -1.4,6" fill="none" stroke="${C.skin.shade}" stroke-width=".9" stroke-linecap="round" opacity=".7"/>`+
  `<path d="M-3.4,10 Q0,12.4 3.4,10" fill="none" stroke="${C.lip}" stroke-width="1.4" stroke-linecap="round"/><path d="M-1.6,12.1 Q0,12.8 1.6,12.1" fill="none" stroke="${C.lip}" stroke-width=".8" stroke-linecap="round" opacity=".5"/>`+
  shadedLocal(hair,C.hair,[-1,-2.2])+
  `<path d="M-0.6,-10.6 C-2,-14 -2.6,-17 -2,-19.6" fill="none" stroke="${C.hair.shade}" stroke-width=".8" opacity=".7"/>`+
  `<path d="M-9,-14 C-5,-18 3,-18.6 8,-15" fill="none" stroke="${C.hair.light}" stroke-width="1.1" opacity=".6" stroke-linecap="round"/></g>`;
}
function headProfile(Hc,ang,eyes,mirrorX){
 const rot=ang+90,id='rh'+(++uid),sx=mirrorX?-1:1;
 const face='M-3,-18.4 C8,-19.4 13.2,-12.4 12.8,-5.4 L13.2,-3.2 C14.8,-1 16.2,1.4 16.2,2.6 C16.2,3.7 14.6,4.2 13.2,4.4 C13.9,5.6 13.9,6.4 13.2,7 C13.9,7.9 13.7,8.9 12.8,9.5 C12.8,11.2 12.4,13.2 10.6,14.4 C8,15.8 4,15.7 0.6,14.2 C-4.2,12.2 -9,10 -12.2,6 C-15.4,1 -15.2,-12.6 -3,-18.4Z';
 const hair='M10.2,-13.4 C6.4,-19.6 -6.6,-21.4 -12.6,-12.4 C-16,-6.2 -15.6,2 -12,7.8 C-9.2,9.6 -6.2,7.6 -5.6,4.2 C-5.2,-1.2 -1.4,-6.4 3,-8.4 C6.4,-10 9,-11.2 10.2,-13.4Z';
 const eye=eyes==='closed'
  ?`<path d="M6.8,-0.6 Q8.8,1.4 10.6,-0.4" fill="none" stroke="${C.eye}" stroke-width="1.1" stroke-linecap="round"/>`
  :`<path d="M6.8,-0.4 Q8.8,-2.4 10.8,-0.8" fill="none" stroke="${C.eye}" stroke-width="1.15" stroke-linecap="round"/><path d="M9.2,-1.5 Q10.6,-0.7 10.2,0.9 Q9.1,0.9 8.9,-0.2Z" fill="${C.eye}"/>`;
 track([[Hc[0]-20,Hc[1]-20],[Hc[0]+20,Hc[1]+20]]);
 return `<g transform="translate(${f(Hc[0])},${f(Hc[1])}) rotate(${f(rot)}) scale(${sx},1)"><clipPath id="${id}"><path d="${face}"/></clipPath>`+
  `<path d="${face}" fill="${C.skin.shade}"/><g clip-path="url(#${id})"><path d="${face}" fill="${C.skin.base}" transform="translate(1.4,-2.2)" filter="url(#rfBlur)"/>`+
  `<circle cx="7" cy="5" r="3.4" fill="${C.blush}" opacity=".3" filter="url(#rfBlur)"/></g>`+
  `<ellipse cx="-2.4" cy="1.6" rx="2.7" ry="4.3" fill="${C.skin.base}" stroke="${C.skin.shade}" stroke-width=".8"/><path d="M-2.6,-0.6 q1.2,2 -0.2,4" fill="none" stroke="${C.skin.shade}" stroke-width=".7"/>`+
  eye+`<path d="M6.4,-4.8 Q8.8,-6.6 11.2,-5" fill="none" stroke="${C.hair.base}" stroke-width="1.1" stroke-linecap="round"/>`+
  `<path d="M12.9,7.1 L11.4,7.5" stroke="${C.lip}" stroke-width="1.1" stroke-linecap="round"/>`+
  shadedLocal(hair,C.hair,[1.2,-2])+
  `<path d="M7,-15.4 C2,-17.6 -6,-17.4 -10.6,-11" fill="none" stroke="${C.hair.light}" stroke-width="1.1" opacity=".6" stroke-linecap="round"/>`+
  `<ellipse cx="-11.6" cy="-10.6" rx="2.2" ry="3.4" transform="rotate(-35 -11.6 -10.6)" fill="${C.tie}"/></g>`;
}
function shadedLocal(d,p,nudge){const id='rl'+(++uid);return `<clipPath id="${id}"><path d="${d}"/></clipPath><path d="${d}" fill="${p.shade}"/><g clip-path="url(#${id})"><path d="${d}" fill="${p.base}" transform="translate(${nudge[0]},${nudge[1]})" filter="url(#rfBlur)"/></g>`}
/* head-local -> world */
function hw(Hc,ang,[x,y],sx=1){const r=(ang+90)*Math.PI/180;x*=sx;return[Hc[0]+x*Math.cos(r)-y*Math.sin(r),Hc[1]+x*Math.sin(r)+y*Math.cos(r)]}
/* ponytail: leaves the head along `out`, then hangs under gravity, resting on the floor if it reaches it */
function ponytail(tie,out,floorY,len=58,sway=0){
 const pts=[tie];let p=tie,d=norm(out);const step=len/8;
 for(let i=1;i<=8;i++){
  const g=Math.min(1,0.28+i*0.12);d=norm(add(mul(d,1-g),[sway*0.25,g]));
  let np=add(p,mul(d,step));
  if(np[1]>floorY-3.5){np=[p[0]+(Math.sign(d[0]||sway||1))*step,floorY-3.5];d=[Math.sign(d[0]||1),0]}
  pts.push(np);p=np;
 }
 const W=[4.6,6.4,7.2,7,6.2,5.2,4.2,3,1.6];
 const s=pts.map((p,i)=>({p,w:W[i]}));
 const outline=ribbon(s,false,true);
 const tipStroke=pts.slice(2).map((q,i)=>i%2?'':'').join('');
 return shaded(smooth(outline),C.hair,{off:2.2,hl:.6,hw:1.6})+
  `<path d="${smooth(pts.slice(1),false)}" fill="none" stroke="${C.hair.shade}" stroke-width=".8" opacity=".55"/>`+
  `<circle cx="${f(tie[0])}" cy="${f(tie[1])}" r="3.2" fill="${C.tie}"/>`;
}
function neck(N,Hc){
 const s=[{p:lerp(N,Hc,-0.1),w:6.2},{p:lerp(N,Hc,0.35),w:5.4},{p:lerp(N,Hc,0.75),w:5.4}];
 return shaded(smooth(ribbon(s,true,true)),C.skin,{off:1.8,hl:0});
}
/* ---------- pose solver ---------- */
function render(P){
 uid=uid||0;bbox={x0:1e9,x1:-1e9,y0:1e9,y1:-1e9};
 const H=P.H,td=dir(P.torso),perp=[-td[1],td[0]];
 const N=add(H,mul(td,LEN.torso));
 const Hc=add(N,mul(dir(P.head),23));
 const front=P.view==='front';
 const shoulder=s=>front?add(add(N,mul(td,-9)),mul(perp,s*P.sw)):add(add(N,mul(td,-10)),mul(perp,-1.5+s*1));
 const hip=s=>front?add(H,mul(perp,s*P.hw)):add(H,mul(perp,s*1.5));
 const limbs={N,H,Hc};
 for(const side of ['L','R']){
  const s=side==='L'?-1:1,lg=P.legs[side],hp=hip(s);
  let K,A;
  if(lg.fk){K=add(hp,mul(dir(lg.fk[0]),LEN.th));A=add(K,mul(dir(lg.fk[1]),LEN.sh))}
  else{const tgt=typeof lg.ik==='function'?lg.ik(limbs):lg.ik;[K,A]=ik(hp,tgt,LEN.th,LEN.sh,lg.bend)}
  limbs['leg'+side]={hp,K,A};
 }
 for(const side of ['L','R']){
  const s=side==='L'?-1:1,am=P.arms[side],sh=shoulder(s);
  let E,W;
  if(am.fk){E=add(sh,mul(dir(am.fk[0]),LEN.ua));W=add(E,mul(dir(am.fk[1]),LEN.fa))}
  else{const tgt=typeof am.ik==='function'?am.ik(limbs):am.ik;[E,W]=ik(sh,tgt,LEN.ua,LEN.fa,am.bend)}
  limbs['arm'+side]={sh,E,W};
 }
 const parts={
  legL:()=>leg(limbs.legL.hp,limbs.legL.K,limbs.legL.A,P.legs.L.k||1)+foot('L'),
  legR:()=>leg(limbs.legR.hp,limbs.legR.K,limbs.legR.A,P.legs.R.k||1)+foot('R'),
  armL:()=>arm(limbs.armL.sh,limbs.armL.E,limbs.armL.W,P.arms.L.hand,P.arms.L.k||1,P.prayer),
  armR:()=>arm(limbs.armR.sh,limbs.armR.E,limbs.armR.W,P.arms.R.hand,P.arms.R.k||1,P.prayer),
  torso:()=>torso(H,P.torso,P.view),
  hips:()=>torso(H,P.torso,P.view,true),
  neck:()=>neck(N,Hc),
  head:()=>P.headView==='front'?headFront(Hc,P.head,P.eyes):headProfile(Hc,P.head,P.eyes,P.headFlip),
  tail:()=>{
   const sx=P.headFlip?-1:1;
   const tie=P.headView==='front'?hw(Hc,P.head,[P.tailSide*8,-14]):hw(Hc,P.head,[-12.6,-11.4],sx);
   const out=P.headView==='front'?[P.tailSide*0.9,0.2]:sub(hw(Hc,P.head,[-24,-12],sx),tie);
   return ponytail(tie,out,P.groundY??0,P.tailLen||58,P.tailSide||0);
  }
 };
 function foot(side){
  const ft=P.legs[side].foot,A=limbs['leg'+side].A,k=P.legs[side].k||1;
  return ft.type==='front'?footFront(A,ft.side,k):footSide(A,ft.angle,k,ft.flip);
 }
 const out={};P.order.forEach(k=>{if(k!=='tail')out[k]=parts[k]()});
 const bb={...bbox};P.groundY=bb.y1;out.tail=parts.tail();bbox=bb;
 const body=P.order.map(k=>out[k]).join('');
 // ground & centre (ponytail excluded from centring)
 const dx=CX-(bbox.x0+bbox.x1)/2, dy=GROUND-(P.groundAt??bbox.y1);
 const contacts=(P.contacts||[]).map(c=>{const p=typeof c==='function'?c(limbs,H):c;return `<ellipse cx="${f(p[0])}" cy="${f(P.groundAt??bbox.y1)+1}" rx="${p[2]||18}" ry="3.2" fill="#1d2a22" opacity=".18" filter="url(#rfBlur2)"/>`}).join('');
 return {svg:`<g transform="translate(${f(dx)},${f(dy)})">${contacts}${body}</g>`,bbox,limbs,dx,dy};
}
const DEFS=`<defs><filter id="rfBlur" x="-30%" y="-30%" width="160%" height="160%"><feGaussianBlur stdDeviation="2"/></filter><filter id="rfBlur2" x="-50%" y="-200%" width="200%" height="500%"><feGaussianBlur stdDeviation="3"/></filter></defs>`;
return {render,DEFS,GROUND,C,LEN,dir,add,mul};
})();


var RP=window.RP=(function(){const {add,dir,mul}=RomiFigure;
const lerp=(a,b,t)=>[a[0]+(b[0]-a[0])*t,a[1]+(b[1]-a[1])*t];
return [
{id:'mountain',view:'front',H:[0,-150],torso:-90,head:-90,headView:'front',eyes:'open',sw:21,hw:10,tailSide:1,
 legs:{L:{fk:[92,90],foot:{type:'front',side:-1}},R:{fk:[88,90],foot:{type:'front',side:1}}},
 arms:{L:{fk:[98,93],hand:92},R:{fk:[82,87],hand:88}},order:['tail','torso','legL','legR','hips','armL','armR','neck','head']},
{id:'tree',view:'front',H:[0,-150],torso:-90,head:-90,headView:'front',eyes:'open',sw:19,hw:8,tailSide:1,prayer:true,
 legs:{L:{fk:[91,90],foot:{type:'front',side:-1}},R:{ik:l=>add(lerp(l.legL.hp,l.legL.K,.4),[15,0]),bend:-1,foot:{type:'side',angle:96,flip:false}}},
 arms:{L:{ik:l=>[l.N[0]-2.2,l.N[1]-66],bend:-1,hand:-90},R:{ik:l=>[l.N[0]+2.2,l.N[1]-66],bend:1,hand:-90}},order:['tail','torso','legL','legR','hips','neck','head','armL','armR']},
{id:'warrior',view:'front',H:[0,-90],torso:-90,head:-90,headView:'profile',headFlip:true,eyes:'open',sw:21,hw:10,tailSide:1,
 legs:{L:{ik:[-86,-8],bend:1,foot:{type:'side',angle:180,flip:true}},R:{ik:[126,-11],bend:-1,foot:{type:'front',side:1}}},
 arms:{L:{fk:[180,180],hand:180},R:{fk:[0,0],hand:0}},order:['tail','torso','legL','legR','hips','armL','armR','neck','head']},
{id:'chair',view:'side',H:[-36,-90],torso:-56,head:-52,headView:'profile',eyes:'open',sw:0,hw:0,
 legs:{L:{ik:[20,-8],bend:-1,k:.84,foot:{type:'side',angle:0}},R:{ik:[25,-8],bend:-1,foot:{type:'side',angle:0}}},
 arms:{L:{fk:[-64,-61],hand:-61,k:.84},R:{fk:[-58,-56],hand:-56}},order:['armL','legL','torso','legR','hips','neck','tail','head','armR']},
{id:'dog',view:'side',H:[0,-140],torso:48,head:80,headView:'profile',eyes:'open',sw:0,hw:0,tailLen:52,
 legs:{L:{ik:[-64,-14],bend:-1,k:.84,foot:{type:'side',angle:16}},R:{ik:[-57,-14],bend:-1,foot:{type:'side',angle:16}}},
 arms:{L:{ik:[100,-4],bend:1,hand:0,k:.84},R:{ik:[107,-4],bend:1,hand:0}},order:['armL','legL','torso','legR','neck','tail','head','armR']},
{id:'seated',view:'front',H:[0,-22],torso:-90,head:-90,headView:'front',eyes:'closed',sw:21,hw:10,tailSide:1,
 legs:{L:{fk:[160,10],foot:{type:'side',angle:6}},R:{fk:[20,170],foot:{type:'side',angle:176,flip:true}}},
 arms:{L:{ik:l=>add(l.legL.K,[12,-12]),bend:-1,hand:150},R:{ik:l=>add(l.legR.K,[-12,-12]),bend:1,hand:30}},order:['tail','torso','legL','legR','hips','armL','armR','neck','head']}
];})();
RP.push(
{id:'child',view:'side',H:[-46,-32],torso:12,head:24,headView:'profile',eyes:'closed',sw:0,hw:0,tailLen:40,
 legs:{L:{fk:[16,182],k:.84,foot:{type:'side',angle:180,flip:true}},R:{fk:[20,182],foot:{type:'side',angle:180,flip:true}}},
 arms:{L:{ik:[118,-4],bend:1,hand:0,k:.84},R:{ik:[124,-4],bend:1,hand:0}},order:['armL','legL','torso','legR','hips','neck','tail','head','armR']},
{id:'cat',view:'side',H:[-50,-80],torso:-12,head:110,headView:'profile',eyes:'closed',sw:0,hw:0,tailLen:46,
 legs:{L:{fk:[92,180],k:.84,foot:{type:'side',angle:180,flip:true}},R:{fk:[88,180],foot:{type:'side',angle:180,flip:true}}},
 arms:{L:{ik:[28,-4],bend:1,hand:0,k:.84},R:{ik:[34,-4],bend:1,hand:0}},order:['armL','legL','torso','legR','hips','neck','tail','head','armR']},
{id:'cow',view:'side',H:[-50,-80],torso:-8,head:-35,headView:'profile',eyes:'open',sw:0,hw:0,tailLen:52,
 legs:{L:{fk:[92,180],k:.84,foot:{type:'side',angle:180,flip:true}},R:{fk:[88,180],foot:{type:'side',angle:180,flip:true}}},
 arms:{L:{ik:[28,-4],bend:1,hand:0,k:.84},R:{ik:[34,-4],bend:1,hand:0}},order:['armL','legL','torso','legR','hips','neck','tail','head','armR']},
{id:'cobra',view:'side',H:[-20,-14],torso:-35,head:-40,headView:'profile',eyes:'open',sw:0,hw:0,tailLen:52,
 legs:{L:{fk:[181,180],k:.84,foot:{type:'side',angle:180,flip:true}},R:{fk:[179,180],foot:{type:'side',angle:180,flip:true}}},
 arms:{L:{ik:[48,-4],bend:1,hand:0,k:.84},R:{ik:[54,-4],bend:1,hand:0}},order:['armL','legL','torso','legR','hips','neck','tail','head','armR']},
{id:'bridge',view:'side',H:[0,-60],torso:143,head:180,headView:'profile',eyes:'closed',sw:0,hw:0,tailLen:40,
 legs:{L:{ik:[60,-6],bend:-1,k:.84,foot:{type:'side',angle:0}},R:{ik:[66,-6],bend:-1,foot:{type:'side',angle:0}}},
 arms:{L:{fk:[8,2],hand:0,k:.84},R:{fk:[6,0],hand:0}},order:['armL','legL','torso','legR','hips','neck','tail','head','armR']}
);

(function(){
  'use strict';
  var stage=document.getElementById('studio'), svg=document.getElementById('fig');
  if(!stage||!svg||!window.RomiFigure||!window.RP)return;
  var fr=(document.documentElement.lang||'en').slice(0,2)==='fr';
  var META=[
    {en:'Mountain',fr:'Montagne',sk:'Tadasana',cue:{en:'Stand tall with your weight even through both feet.',fr:'Tenez-vous droit, le poids réparti sur les deux pieds.'}},
    {en:'Tree',fr:'Arbre',sk:'Vrikshasana',cue:{en:'Rest one foot on the inner calf or thigh, never on the knee.',fr:"Posez un pied sur l'intérieur du mollet ou de la cuisse, jamais sur le genou."}},
    {en:'Warrior II',fr:'Guerrier II',sk:'Virabhadrasana II',cue:{en:'Front knee over the ankle, arms long and level.',fr:'Genou avant au-dessus de la cheville, bras longs à l’horizontale.'}},
    {en:'Chair',fr:'Chaise',sk:'Utkatasana',cue:{en:'Sit back as if into a chair, arms reaching forward and up.',fr:'Asseyez-vous vers l’arrière comme sur une chaise, bras tendus vers l’avant et le haut.'}},
    {en:'Downward-facing dog',fr:'Chien tête en bas',sk:'Adho Mukha Svanasana',cue:{en:'Press the floor away and lengthen through the spine.',fr:'Repoussez le sol et allongez la colonne.'}},
    {en:'Seated meditation',fr:'Méditation assise',sk:'Sukhasana',cue:{en:'Sit comfortably cross-legged and let the breath settle.',fr:'Asseyez-vous en tailleur, confortablement, et laissez la respiration s’apaiser.'}},
    {en:'Child’s pose',fr:'Posture de l’enfant',sk:'Balasana',cue:{en:'Sit back toward your heels and rest your forehead on the mat.',fr:'Ramenez les fesses vers les talons et posez le front sur le tapis.'}},
    {en:'Cat',fr:'Chat',sk:'Marjaryasana',cue:{en:'Round your back toward the ceiling and let your head relax down.',fr:'Arrondissez le dos vers le plafond et laissez la tête se relâcher.'}},
    {en:'Cow',fr:'Vache',sk:'Bitilasana',cue:{en:'Let your belly soften toward the mat and lift your gaze gently.',fr:'Laissez le ventre descendre doucement vers le tapis et levez légèrement le regard.'}},
    {en:'Cobra',fr:'Cobra',sk:'Bhujangasana',cue:{en:'Press lightly into your hands and lift the chest, elbows close to your sides.',fr:'Appuyez légèrement sur les mains et soulevez la poitrine, coudes près du corps.'}},
    {en:'Bridge',fr:'Pont',sk:'Setu Bandha Sarvangasana',cue:{en:'Feet hip-width apart, press through your feet to lift the hips.',fr:'Pieds écartés à la largeur des hanches, poussez dans les pieds pour soulever le bassin.'}}
  ];
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  var idx=0,busy=false;
  var h=RomiFigure.DEFS+'<ellipse cx="200" cy="337" rx="170" ry="7" fill="#D9D6CB" opacity=".5"/><rect class="mat-shape" x="34" y="322" width="332" height="12" rx="6" fill="#CC917A"/><rect x="34" y="330" width="332" height="4" rx="2" fill="#B5674A" opacity=".5"/>';
  RP.forEach(function(p,i){h+='<g class="pose'+(i===0?' on':'')+'" data-i="'+i+'">'+RomiFigure.render(p).svg+'</g>'});
  svg.innerHTML=h;
  var q=function(id){return document.getElementById(id)};
  function text(){
    var m=META[idx],nm=fr?m.fr:m.en;
    q('poseName').textContent=nm;q('poseSk').textContent=m.sk;q('poseCue').textContent=fr?m.cue.fr:m.cue.en;
    q('poseCount').textContent=(stage.dataset.of||'Pose {i} of {n}').replace('{i}',idx+1).replace('{n}',META.length);
    q('figBtn').setAttribute('aria-label',(stage.dataset.label||'{pose}').replace('{pose}',nm));
    return nm;
  }
  function next(){
    if(busy)return;
    idx=(idx+1)%META.length;
    var nm=text();q('poseLive').textContent=(stage.dataset.live||'{pose}').replace('{pose}',nm);
    Array.prototype.forEach.call(svg.querySelectorAll('.pose'),function(g){g.classList.toggle('on',+g.dataset.i===idx)});
    if(!reduce.matches){busy=true;setTimeout(function(){busy=false},520)}
  }
  text();
  q('figBtn').addEventListener('click',next);q('nextPose').addEventListener('click',next);
})();
